import React, { useState } from 'react';
import HelperIcon from './HelperIcon';
import { helperContent } from '../content/helper-content';

const ApprovalPanel = ({ matches, onApprove, onReject, onClose }) => {
  const [processing, setProcessing] = useState({});

  const handleApprove = async (matchId) => {
    setProcessing(prev => ({ ...prev, [matchId]: 'approving' }));
    try {
      await onApprove(matchId);
    } finally {
      setProcessing(prev => ({ ...prev, [matchId]: null }));
    }
  };

  const handleReject = async (matchId) => {
    setProcessing(prev => ({ ...prev, [matchId]: 'rejecting' }));
    try {
      await onReject(matchId);
    } finally {
      setProcessing(prev => ({ ...prev, [matchId]: null }));
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="approval-panel-overlay" onClick={handleOverlayClick}>
      <div className="approval-panel">
        <header className="approval-panel-header">
          <h2>Pending Assignments</h2>
          <HelperIcon
            title={helperContent.matchApproval?.title || "Assignment Approval"}
            content={helperContent.matchApproval?.content || "Review AI-suggested matches before they become active."}
            size="small"
          />
          <button className="close-btn" onClick={onClose} aria-label="Close panel">
            &times;
          </button>
        </header>

        <div className="pending-list">
          {matches.length === 0 ? (
            <div className="pending-empty">
              <div className="empty-icon">✓</div>
              <p>No pending assignments to review.</p>
            </div>
          ) : (
            matches.map(match => (
              <PendingMatchCard
                key={match.match_id}
                match={match}
                onApprove={() => handleApprove(match.match_id)}
                onReject={() => handleReject(match.match_id)}
                isProcessing={processing[match.match_id]}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

const PendingMatchCard = ({ match, onApprove, onReject, isProcessing }) => {
  return (
    <div className="pending-match-card">
      <div className="match-pairing">
        <div className="match-student">
          <span className="match-label">Student</span>
          <span className="match-value">
            {match.student_grade || 'Unknown Grade'}
          </span>
          <small style={{ color: 'var(--lrbrain-text-light)', fontSize: '0.75rem' }}>
            {match.student_subjects || 'No subjects'}
          </small>
        </div>

        <div className="match-arrow">→</div>

        <div className="match-tutor">
          <span className="match-label">Tutor</span>
          <span className="match-value">{match.tutor_name}</span>
        </div>
      </div>

      <div className="match-score">
        <div>
          <span className="score-value">{match.confidence_score}%</span>
          <span className="score-label"> Match Score</span>
        </div>
      </div>

      {match.explanation && (
        <p className="match-explanation">{match.explanation}</p>
      )}

      <div className="match-actions">
        <button
          className="btn-approve"
          onClick={onApprove}
          disabled={isProcessing}
        >
          {isProcessing === 'approving' ? 'Approving...' : '✓ Approve'}
        </button>
        <button
          className="btn-reject"
          onClick={onReject}
          disabled={isProcessing}
        >
          {isProcessing === 'rejecting' ? 'Rejecting...' : '✗ Reject'}
        </button>
      </div>
    </div>
  );
};

export default ApprovalPanel;
